import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/insify.webp';
import screenshot_target from '../../../images/letterfunnel/koenthijssen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Koen Thijssen"
      firstname="Koen"
      companyname="Insify"
      competition="Alicia en Centraal Beheer"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/koenthijssen.js